import ForwarderInfo from './ForwarderInfo';

const ForwarderInfoConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: [],
  routes: [
    {
      path: 'forwarder-info',
      element: <ForwarderInfo />,
    },
  ],
};

export default ForwarderInfoConfig;
